export default __webpack_public_path__ + "static/media/npmx.1e9b78bd.png";